export type MenuItem = {
  name: string
  description?: string
  price: string
}

export type MenuCategory = {
  id: string
  name: string
  image?: string
  items: MenuItem[]
  subcategories?: { name: string; items: MenuItem[] }[]
}

export const menuData: MenuCategory[] = [
  {
    id: 'compartir',
    name: 'Para Compartir',
    image:
      'https://cdn.magicpatterns.com/uploads/shF5JfuwYVPApAQg3UYr4A/restaurante_cabrera_4.jpg',
    items: [
      {
        name: 'Albóndigas al vino',
        description:
          'Jugosas albóndigas de res bañadas en salsa pomodoro y vino tinto con queso cheddar, tocineta crocante, chile chipotle en polvo. Acompañadas de pan baguette',
        price: '$46.900',
      },
      {
        name: 'Burrata nolita',
        description:
          'Cremosa burrata aderezada con aceite de oliva, perejil fresco picado, tomates cherry sobre berenjena tibia a la brasa',
        price: '$50.900',
      },
      {
        name: 'Camarones crocantes',
        description:
          'Camarones crujientes rebozados en panko con chile chipotle, acompañados de mayonesa de ajo, salsa de gulupa y cascos de limón',
        price: '$42.900',
      },
      {
        name: 'Carpaccio ciprianni',
        description:
          'Finas láminas de lomo de res sellado en costra de pimientas, rúgula con tomates secos, reducción balsámica, parmesano',
        price: '$50.900',
      },
      {
        name: 'Cazuela de champiñones',
        description:
          'Champiñones salteados con mantequilla, ajo y vino blanco gratinados con queso. Con pan baguette',
        price: '$35.900',
      },
      {
        name: 'Chicharrones',
        description: 'Con guacamole, sour cream y limón',
        price: '$42.900',
      },
      {
        name: 'Croquetas de pulpo',
        description: 'Con tinta de calamar, mayo trufada y pimentón de la vera',
        price: '$32.900',
      },
      {
        name: 'Dip de alcachofas y espinaca',
        description: 'Gratinado con mozzarella y queso paipa',
        price: '$37.900',
      },
      {
        name: 'Espárragos gratinados',
        description: 'Con queso azul, mozzarella y parmesano',
        price: '$34.900',
      },
      {
        name: 'Fajitas de entraña USA',
        description:
          'Al carbón con vegetales, tortillas, guacamole, salsa diabla',
        price: '$85.900',
      },
      {
        name: 'Hummus de garbanzo',
        description: 'Con tahine, queso de cabra, pan pita',
        price: '$28.900',
      },
      {
        name: 'Mac and cheese',
        description:
          'Macarrones en salsa de quesos, tocineta crujiente, cebollín',
        price: '$34.900',
      },
      { name: 'Mac and cheese con roast beef', price: '$42.900' },
      {
        name: 'Maíz La Habana',
        description:
          'Desgranado con mayo de ajo, queso costeño, chile chipotle',
        price: '$36.900',
      },
      {
        name: 'Mini burguer selection',
        description: 'x2: $30.900 / x4: $54.900',
        price: 'Variado',
      },
      {
        name: 'Molcajete de aguacate',
        description: 'Guacamole en mesa con totopos',
        price: '$36.900',
      },
      { name: 'Nachos pollo BBQ', price: '$48.900' },
      { name: 'Nachos pork ribs', price: '$45.900' },
      {
        name: 'Papas Trufadas',
        description: 'Con aceite de trufa y parmesano',
        price: '$24.900',
      },
      {
        name: 'Pulpo cabrera',
        description:
          'A la parrilla con papas doradas, espárragos, lechugas asiáticas',
        price: '$82.900',
      },
      { name: 'Tartar de atún', price: '$45.900' },
      { name: 'Tostadas Spicy Salmon', price: '$29.900' },
    ],
  },
  {
    id: 'sopas',
    name: 'Sopas',
    items: [
      { name: 'Sopa de cebolla con hongos', price: '$34.900' },
      { name: 'Sopa gumbo de camarones y chorizo', price: '$36.900' },
    ],
  },
  {
    id: 'hamburguesas',
    name: 'Hamburguesas',
    image:
      'https://cdn.magicpatterns.com/uploads/5MNExqAfM4W39C5ccx47WL/restaurante_bar_6.jpg',
    items: [
      { name: 'Chicken sandwich', price: '$48.900' },
      { name: 'Falafel Burguer Vegetariana', price: '$39.900' },
      { name: 'Hamburguesa 1/2 Libra Al Carbón', price: '$53.900' },
      { name: 'Hamburguesa 1/4 Cheese & Bacon', price: '$45.900' },
      { name: 'Hamburguesa American Angus', price: '$58.900' },
      { name: 'Hamburguesa Cabrera', price: '$52.900' },
      { name: 'Hamburguesa Sex And The City', price: '$46.900' },
      { name: 'Hamburguesa Sweet n Spicy', price: '$49.900' },
      { name: 'Sandwich Cabrera', price: '$59.900' },
      { name: 'Sandwich de roast beef', price: '$53.900' },
    ],
  },
  {
    id: 'ensaladas',
    name: 'Ensaladas',
    items: [
      { name: 'Ensalada Con Pollo', price: '$39.900' },
      { name: 'Ensalada de Atún', price: '$64.900' },
      { name: 'Ensalada de Quínoa con Salmón', price: '$59.900' },
    ],
  },
  {
    id: 'fuertes',
    name: 'Platos Fuertes',
    image:
      'https://cdn.magicpatterns.com/uploads/5Xyz55VizUErUiCbdUZjzw/carne_parrilla.jpg',
    items: [],
    subcategories: [
      {
        name: 'Carnes Importadas',
        items: [
          { name: 'Cabrera Steak 280gr', price: '$182.900' },
          { name: 'Rib Eye Americano 400gr', price: '$259.900' },
          { name: 'New York Steak Argentino 350gr', price: '$131.900' },
          { name: 'Rib Eye Argentino 350gr', price: '$150.900' },
        ],
      },
      {
        name: 'Carnes Nacionales',
        items: [
          { name: 'Bife De Paleta 300gr', price: '$73.900' },
          { name: 'New York Nacional 320gr', price: '$80.900' },
          { name: 'Baby beef 280gr', price: '$76.900' },
          { name: 'Asado de tira', price: '$87.900' },
          { name: 'Parrillada para 2', price: '$122.900' },
          { name: 'Parrillada para 4', price: '$170.900' },
          { name: 'Punta de Anca 350gr', price: '$81.900' },
        ],
      },
      {
        name: 'Pollo',
        items: [
          { name: 'Medio pollo orgánico al horno', price: '$63.900' },
          { name: 'Pechuga a la plancha', price: '$43.900' },
          { name: 'Pechuga Ahumada', price: '$51.900' },
        ],
      },
      {
        name: 'Cerdo',
        items: [
          { name: 'BBQ Pork Ribs', price: '$73.900' },
          { name: 'Pork Belly al Horno', price: '$68.900' },
          { name: 'Punta de anca de cerdo al carbón', price: '$52.900' },
        ],
      },
      {
        name: 'Pescado',
        items: [
          { name: 'Salmón Bengalí', price: '$77.900' },
          { name: 'Pesca del día en costra de hierbas', price: '$80.900' },
        ],
      },
      {
        name: 'Arroces',
        items: [
          { name: 'Arroz cabrera de mar', price: '$64.900' },
          { name: 'Arroz cabrera', price: '$59.900' },
        ],
      },
    ],
  },
  {
    id: 'sides',
    name: 'Side Orders',
    items: [
      { name: 'Ensalada de la huerta', price: '$13.900' },
      { name: 'Anillos de cebolla', price: '$17.900' },
      { name: 'Cheese & bacon potatoes', price: '$24.900' },
      { name: 'Vegetales salteados', price: '$14.900' },
      { name: 'Pure de papa', price: '$20.900' },
      { name: 'Skin potato', price: '$15.900' },
      { name: 'Papas Cabrera', price: '$17.900' },
      { name: 'Cubos de papa', price: '$16.900' },
    ],
  },
  {
    id: 'postres',
    name: 'Postres',
    items: [
      { name: 'Fudge & Peanut Butter Ice Cream', price: '$28.900' },
      { name: 'Carrot Cake', price: '$25.900' },
      { name: 'Blueberry New York Cheesecake', price: '$29.900' },
      { name: 'Profiteroles', price: '$28.900' },
      { name: 'Deleite de coco', price: '$31.900' },
      { name: 'Cheesecake de oreo', price: '$29.900' },
      { name: 'Brownie de milo', price: '$26.900' },
    ],
  },
  {
    id: 'ninos',
    name: 'Niños',
    items: [
      { name: 'Nuggets de pollo apanados con papas', price: '$32.900' },
      { name: 'Pechuga Baby Con Papas', price: '$30.900' },
      { name: 'Mini Baby Con Papas', price: '$37.900' },
    ],
  },
  {
    id: 'cocteles',
    name: 'Cócteles',
    image:
      'https://cdn.magicpatterns.com/uploads/biFRo2gJ5vHADAf7dQ5Bwk/resaturante_cabrerabar_2.jpg',
    items: [],
    subcategories: [
      {
        name: 'Los Cabrera (Firma)',
        items: [
          { name: 'Limoncello Spritz', price: '$46.900' },
          { name: 'Vintage Tonic', price: '$65.900' },
          { name: 'Strawberry Martini', price: '$54.900' },
          { name: 'Charlotte Mojito', price: '$43.900' },
          { name: 'Pompodure', price: '$61.900' },
          { name: 'ST Germain Spritz', price: '$42.900' },
          { name: 'Two Souls Mule', price: '$60.900' },
          { name: 'Frida Margarita', price: '$65.900' },
          { name: 'Mezcal Mule', price: '$61.900' },
          { name: 'Isabella', price: '$65.900' },
          { name: 'Paloma Cabrera', price: 'desde $51.900' },
          { name: 'Green Gentleman', price: 'desde $49.900' },
          { name: 'Brooklyn Mule', price: 'desde $49.900' },
          { name: 'Vin Brulet', price: '$47.900' },
          { name: 'Alcapone', price: 'desde $49.900' },
        ],
      },
    ],
  },
  {
    id: 'cervezas',
    name: 'Cervezas',
    items: [
      { name: 'Club Colombia draft', price: '$15.900' },
      { name: 'Stella Artois draft', price: '$17.900' },
      { name: 'Heineken', price: '$19.900' },
      { name: 'Corona', price: '$19.900' },
      { name: 'BBC Artesanal', price: '$20.900' },
      { name: 'Erdinger Weissbier', price: '$37.900' },
      { name: 'Erdinger Dunkel', price: '$37.900' },
      { name: 'Paulaner', price: '$41.900' },
      { name: 'Michelada Cabrera', price: '$29.900' },
      { name: 'Michelada Mojito', price: '$35.900' },
      { name: 'Corona Cero (sin alcohol)', price: '$17.900' },
    ],
  },
  {
    id: 'vinos',
    name: 'Vinos',
    items: [],
    subcategories: [
      {
        name: 'Tintos (Top Selections)',
        items: [
          {
            name: 'Tarapacá Reserva Cabernet',
            price: 'Copa $39.900 / $187.900',
          },
          {
            name: 'Las Moras Barrel Select Malbec',
            price: 'Copa $42.900 / $199.900',
          },
          {
            name: 'Robert Mondavi Woodbridge',
            price: 'Copa $43.900 / $209.900',
          },
          {
            name: 'Sibaris Gran Reserva Pinot Noir',
            price: 'Copa $60.900 / $312.900',
          },
          { name: 'Santa Rita 120 Cabernet', price: 'Copa $29.900 / $136.900' },
        ],
      },
    ],
  },
  {
    id: 'licores',
    name: 'Licores',
    items: [],
    subcategories: [
      {
        name: 'Whisky Single Malt',
        items: [
          { name: 'Glenfiddich 12', price: 'Trago $48.900' },
          { name: 'Glenfiddich 15', price: 'Trago $63.900' },
          { name: 'Glenfiddich 18', price: 'Trago $82.900' },
          { name: 'The Macallan 12 Double Cask', price: 'Trago $72.900' },
          { name: 'The Macallan 15 Double Cask', price: 'Trago $135.900' },
          { name: 'Glenmorangie 10', price: 'Copa $39.900' },
        ],
      },
    ],
  },
]
